function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
// import PropTypes from 'prop-types'
import { wrapDisplayName } from '../../../utils';
import { addExtension, getEnvVar, removeExtension } from './helpers';

/**
 * A function that returns a React HOC for uploading files to (Cloudinary)[https://cloudinary.com].
 *
 * `cloudinaryUploader` exposes the following props to the wrapped component:
 * - `upload`: A function that submits a `POST` request to the Cloudinary endpoint with the `file` object and `fileData`.
 * - `uploadStatus`: A string representing the status of the `upload` request, either `uploading`, `upload-success`, or `upload-failure`.
 *
 * @name cloudinaryUploader
 * @type Function
 * @param {string} cloudName - The name of the Cloudinary cloud to upload to. Can also be set via `CLOUDINARY_CLOUD_NAME` in `process.env`.
 * @param {string} bucket - The name of the Cloudinary bucket to upload to. Can also be set via `CLOUDINARY_BUCKET` in `process.env`.
 * @param {Object} apiAdapter - Adapter that responds to `post` with a Promise
 * @param {string} [uploadPreset=default] - The name of the Cloudinary upload preset. Can also be set via `CLOUDINARY_UPLOAD_PRESET` in `process.env`.
 * @param {string} [endpoint=https://api.cloudinary.com/v1_1/] - The endpoint for the upload request. Can also be set via `CLOUDINARY_ENDPOINT` in `process.env`.
 * @param {string} [fileType=auto] - The type of file.
 * @param {string} [cloudinaryPublicId] - The name of the file stored in Cloudinary.
 * @param {string} [createPublicId] - A function to generate a custom public id for the uploaded file. This function is passed the file object and is expected to return a string. Overridden by the `cloudinaryPublicId` prop.
 * @param {object} [requestOptions=DEFAULT_REQUEST_OPTIONS] - Options for the request, as specified by (`lp-requests`)[https://github.com/LaunchPadLab/lp-requests/blob/master/src/http/http.js].
 * @returns {Function} - A HOC that can be used to wrap a component.
 *
 *
 * @example
 *
 * function CloudinaryFileInput ({ upload, uploadStatus, input, meta ... }) {
 *   const { onChange } = input
 *   const { submit } = meta
 *   return (
 *      <FileInput
 *        input={ input }
 *        meta={ meta }
 *        onLoad={ (fileData, file) => upload(fileData, file).then(() => submit(form)) }
 *        className={ uploadStatus }
 *      />
 *   )
 * }
 *
 * CloudinaryFileInput.propTypes = {
 *   ...formPropTypes,
 *   upload: PropTypes.func.isRequired,
 *   uploadStatus: PropTypes.string.isRequired,
 * }
 *
 * export default compose(
 *    cloudinaryUploader({
 *      cloudName: 'my-cloudinary-cloud-name',
 *      bucket: 'my-cloudinary-bucket',
 *    }),
 * )(CloudinaryFileInput)
 *
 */

// Status enum
export var CloudinaryUploadStatus = {
  LOADING: 'uploading',
  SUCCESS: 'upload-success',
  FAILURE: 'upload-failure'
};

// Option defaults
var DEFAULT_ENDPOINT = 'https://api.cloudinary.com/v1_1';
var DEFAULT_FILE_TYPE = 'auto';
var DEFAULT_UPLOAD_PRESET = 'default';
var DEFAULT_REQUEST_OPTIONS = {
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json'
  },
  mode: 'cors'
};

// Test for all forbidden characters (defined by Cloudinary) and spaces
var FILE_NAME_PATTERN = /[\s?&#\\%<>]/gi;

// Throws an error when a required param is not found
function requireParam(paramName) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Error';
  throw new Error("".concat(context, ": required param ").concat(paramName, " not provided"));
}

// Returns true when an a file is a pdf.
function isPdf(file) {
  return file.type === 'application/pdf';
}
function isImage(file) {
  return file.type.split('/')[0] === 'image';
}

/*
 * The default public id creator returns the sanitized name of the file by
 * replacing invalid characters (incl. those that may be html escaped).
 * Cloudinary does _not_ handle html escaping well via the API our their
 * dashboard so it's best to avoid it entirely.
 *
 * Source: https://support.cloudinary.com/hc/en-us/articles/115001317409--Legal-naming-conventions
 */
function defaultCreatePublicId(file) {
  var fileName = getFileName(file);
  var decodedFileName = decodeFileName(fileName);
  return sanitizeFileName(decodedFileName);
}
function getFileName(file) {
  if (file.name) return file.name;
  return 'file_upload_' + Date.now();
}

// Attempts to decode html escaped characters. If this fails, attempts to strip
// percentages not acting as valid html escaping and tries again. If all else
// fails, returns the original name.
function decodeFileName(name) {
  try {
    try {
      return decodeURIComponent(name);
    } catch (e) {
      return decodeURIComponent(name.replace(/%(?=\D+)/gi, ''));
    }
  } catch (e) {
    return name;
  }
}

// Replaces forbidden characters with '_' and removes duplicate underscores
function sanitizeFileName(name) {
  var validFileName = name.trim().replace(FILE_NAME_PATTERN, '_');
  return validFileName.replace(/_+/gi, '_');
}

// Removes file extension from file name if asset is an image or pdf
// Otherwise, Cloudinary will add an extra extension to the file name
// Ensure extension is present on "raw" file types (e.g., .xls)
function serializePublicId(publicId, file) {
  if (!publicId) return;
  return isPdf(file) || isImage(file) ? removeExtension(publicId) : addExtension(publicId, file);
}
function cloudinaryUploader() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Wrapped) {
    var _class;
    return _class = /*#__PURE__*/function (_Component) {
      _inherits(Wrapper, _Component);
      var _super = _createSuper(Wrapper);
      function Wrapper(props) {
        var _this;
        _classCallCheck(this, Wrapper);
        _this = _super.call(this, props);
        var config = _objectSpread(_objectSpread({}, options), props);
        var _config$cloudName = config.cloudName,
          cloudName = _config$cloudName === void 0 ? getEnvVar('CLOUDINARY_CLOUD_NAME') || requireParam('cloudName', 'cloudinaryUploader') : _config$cloudName,
          _config$bucket = config.bucket,
          bucket = _config$bucket === void 0 ? getEnvVar('CLOUDINARY_BUCKET') || requireParam('bucket', 'cloudinaryUploader') : _config$bucket,
          _config$uploadPreset = config.uploadPreset,
          uploadPreset = _config$uploadPreset === void 0 ? getEnvVar('CLOUDINARY_UPLOAD_PRESET') || DEFAULT_UPLOAD_PRESET : _config$uploadPreset,
          _config$endpoint = config.endpoint,
          endpoint = _config$endpoint === void 0 ? getEnvVar('CLOUDINARY_ENDPOINT') || DEFAULT_ENDPOINT : _config$endpoint,
          _config$apiAdapter = config.apiAdapter,
          apiAdapter = _config$apiAdapter === void 0 ? requireParam('apiAdapter', 'cloudinaryUploader') : _config$apiAdapter,
          _config$fileType = config.fileType,
          fileType = _config$fileType === void 0 ? DEFAULT_FILE_TYPE : _config$fileType,
          _config$requestOption = config.requestOptions,
          requestOptions = _config$requestOption === void 0 ? DEFAULT_REQUEST_OPTIONS : _config$requestOption,
          _config$createPublicI = config.createPublicId,
          createPublicId = _config$createPublicI === void 0 ? defaultCreatePublicId : _config$createPublicI,
          cloudinaryPublicId = config.cloudinaryPublicId;
        // Build request function using config
        _this.cloudinaryRequest = function (fileData, file) {
          var publicId = cloudinaryPublicId || createPublicId(file);
          var url = "".concat(endpoint, "/").concat(cloudName, "/").concat(fileType, "/upload");
          var body = {
            file: fileData,
            folder: bucket,
            upload_preset: uploadPreset,
            public_id: serializePublicId(publicId, file)
          };
          return apiAdapter.post(url, body, requestOptions);
        };
        _this.upload = _this.upload.bind(_assertThisInitialized(_this));
        _this.state = {
          uploadStatus: ''
        };
        return _this;
      }
      _createClass(Wrapper, [{
        key: "upload",
        value: function upload(fileData, file) {
          var _this2 = this;
          this.setState({
            uploadStatus: CloudinaryUploadStatus.LOADING
          });
          return this.cloudinaryRequest(fileData, file).then(function (res) {
            _this2.setState({
              uploadStatus: CloudinaryUploadStatus.SUCCESS
            });
            return res;
          })["catch"](function (error) {
            _this2.setState({
              uploadStatus: CloudinaryUploadStatus.FAILURE
            });
            throw error;
          });
        }
      }, {
        key: "render",
        value: function render() {
          var uploadStatus = this.state.uploadStatus;
          return /*#__PURE__*/React.createElement(Wrapped, _extends({
            upload: this.upload,
            uploadStatus: uploadStatus
          }, this.props));
        }
      }]);
      return Wrapper;
    }(Component), _defineProperty(_class, "displayName", wrapDisplayName(Wrapped, 'cloudinaryUploader')), _class;
  };
}
export default cloudinaryUploader;